import type { IERPUser } from '@admin-panel/types';
import { useGetIdentity, useLink, useLogout, useMenu, usePermissions } from '@refinedev/core';
import { type ReactNode, useMemo } from 'react';
import { useMobileLayout } from '../Layout/useMobileLayout';
import DesktopSider from './DesktopSider';
import MobileSider from './MobileSider';
import { filterMenuItemsByRoles } from './helpers';

const Sider = ({ mobileTitle }: { mobileTitle?: ReactNode }) => {
  const isMobile = useMobileLayout();
  const Link = useLink();
  const { menuItems, selectedKey } = useMenu();
  const { data: userRoles } = usePermissions<Array<string>>({});
  const { data: user } = useGetIdentity<IERPUser>();
  const { mutate: logout } = useLogout();
  const resolvedRoles = useMemo(() => {
    if (userRoles && userRoles.length >= 0) {
      return userRoles;
    }

    if (user?.roles) {
      return user.roles.map(role => role.name);
    }

    return [];
  }, [userRoles, user?.roles]);

  const filteredMenuItems = useMemo(
    () => filterMenuItemsByRoles(menuItems, resolvedRoles),
    [menuItems, resolvedRoles],
  );

  if (isMobile) {
    return (
      <MobileSider
        menuItems={filteredMenuItems}
        selectedKey={selectedKey}
        Link={Link}
        user={user}
        onLogout={() => logout()}
        title={mobileTitle}
      />
    );
  }

  return (
    <DesktopSider
      menuItems={filteredMenuItems}
      selectedKey={selectedKey}
      Link={Link}
      user={user}
      onLogout={() => logout()}
    />
  );
};

export default Sider;
